module.exports = __webpack_public_path__ + "img/nuestra_esecncia_boton.745b213e.png";